import { ListGroup, ListGroupItem } from "react-bootstrap";


type propsType = {
    listData: string[];
}

const MoveList = (prpos: propsType) => {
    
    return (
        <div>
            <ListGroup id="list" className="w-100">
            {
                prpos.listData.map(value=> <ListGroupItem>{value}</ListGroupItem>)
                
            }
            </ListGroup>
           
        </div>
    );

    
}

export default MoveList